import React, { useContext, useEffect } from 'react';
import { renderToString } from 'react-dom/server';
import {getConfiguration, removePrintOverlay, parseHandicap, getAggregationAndBetFromBetId, isAsianHandicap, restoreTicketDataWithUkCombinations, isUKCombinationMaskEnabled, getDatastoreWarName, getBarcode, getBarcodeApk, getFormattedTimestamp, getFormattedFullTimestamp } from '../../data/utils';
import { ControlPanelContext } from '../control-panel-context/ControlPanelConf';
import BorderedTicket from './bordered-ticket/BorderedTicket';
import IsibetHorseTicket from './third-party-ticket/IsibetHorseTicket';
import MstbetHorseTicket from './third-party-ticket/MstbetHorseTicket';
import PlainTicket from './plain-ticket/PlainTicket';
import FlashbetTicket from './flashbet-ticket/FlashbetTicket';
import { TicketPrinterContext } from './TicketPrinterConf';
import { ShopContext } from '../shop/ShopConf';
import { systemCode, xs_isMobile, xs_languageCode } from '../..';
import { borderedTicketStyle, flashbetTicketStyle, plainTicketStyle, printScript } from './styleScriptFactory';
import { useGetBase64Img} from './useGetBase64Img';
import { getTextTicket, whitespaceBitmap } from './textual-tickets-utilities';
import { getEnv } from '../env';
import $ from 'jquery';

function TicketPrinter(props) {
	const ticketPrinterContext = useContext(TicketPrinterContext);
	let ticketData = ticketPrinterContext.ticketData;
	if(isUKCombinationMaskEnabled() && ticketData.purchaseType === 'systembets'){
		restoreTicketDataWithUkCombinations(ticketData);
	}

	const isCashout = ticketPrinterContext.isCashoutPrint;
	if(ticketData && isCashout){
		ticketData.printCashoutLabel = isCashout;
	}
	const terminalCopy = ticketPrinterContext.terminalCopy;
	const printAgainTerminalRec = ticketPrinterContext.reprintTerminalReceipt;
	const controlPanelContext = useContext(ControlPanelContext);
	const shopContext = useContext(ShopContext);
	const skinProperties = shopContext.enabled ? shopContext.skinProperties : null;
	const conf = getConfiguration();
	const frontendType = shopContext.enabled? shopContext.type : "ONLINE";
	const user = props.user;
	const aamsEnviroment = !conf.nas; // TODO: add "isEstero" in configuration
	
	const styleMarginZero = window.systemPrinterStyle? window.systemPrinterStyle : '';
	const [customerLogo] = useGetBase64Img(`${getEnv('REACT_APP_API_DOMAIN')}/${getDatastoreWarName()}/content/images/customer-logo/${conf.logo}`, true);
	const [aamsLogo] = useGetBase64Img(`${getEnv('REACT_APP_API_DOMAIN')}/${getDatastoreWarName()}/content/images/loghi_aams.svg`, aamsEnviroment);
	const goOnWithPrint = (customerLogo && (!aamsEnviroment || aamsLogo));
	
	let ticketType = 'plain';
	if(controlPanelContext != null && controlPanelContext.printerSettings != null){
		ticketType = controlPanelContext.printerSettings.borderedTicket? 'bordered':'plain';
	}	
	if(ticketType === 'plain'){
		// check the plain ticket version setted for this customer
		if(conf.ptv){
			ticketType = conf.ptv === 'FLASHBET'? 'flashbet' : ticketType;
		}
	}

	
	function getTicketCssAndPrintScript(idTicket){
	    let styleScriptTag = '';
		switch(ticketType){
			case 'bordered':
                styleScriptTag = borderedTicketStyle;
                break;
			case 'plain':
                styleScriptTag = plainTicketStyle;
                break;
			case 'flashbet':
                styleScriptTag = flashbetTicketStyle;
                break;
            default:
                break;
		}
		const adjCss = conf.tcss? `<style>${conf.tcss}</style>` : '';
	    return styleScriptTag + adjCss +  printScript.replace(/{{ID_TICKET}}/g, idTicket);
	}




	
	function printOverlayRemoverFinalFunction (){
		if(shopContext.enabled){
			shopContext.removeMonitorMessage();
		}
	}
	
	function removePrintIframe(){
		//$("#frame-print-ticket").remove();
		const framePrintTicket = $("#frame-print-ticket")?.get(0);
		console.debug("removing #frame-print-ticket [ID_TICKET="+framePrintTicket?.contentWindow?.idTicket+"] [PRINT_STATUS="+framePrintTicket?.contentWindow?.PRINT_STATUS+"]");
		//On mobile devices the afterPrint callback(see styleScriptFactory.js) is fired early, so we remove the print iframe after a timeout.
		//This is because if the print iframe is removed too early, the content of the main window will be printed instead of the content of the print iframe.
		//It's as if the window.print() function is called twice: the first time when the user clicks on the print icon, the second time when the user selects the printer (or the "save as PDF" option)
		//We set a fairly long timeout, so the user has enough time to select the desired printer
		if(xs_isMobile) {
			setTimeout(() => {
				$(framePrintTicket)?.remove();
			}, 20000);
		}else{
			$(framePrintTicket)?.remove();
		}	
	}

	function appendPrintIframe(iframeToAppend) {
		document.body.appendChild(iframeToAppend);
	}
	
	const printTextTicketOldSport = shopContext.enabled     	 && 
									shopContext.isAppApkOldSport && 
									window.getPrintSettings      && 
									window.getTicketAppForReact  &&
									window.printTicketApp   	 &&
									window.getPrintSettings()    != 'ORDINARY_PRINTER';
	
	//window.android = { printTicketApp : function(ticket){debugger; console.log(ticket)} , printBitmap : function(bm) {console.log(bm)}, printQrCode : function(bm) {console.log(bm)}};
									
	const printTextTicketApk = shopContext.enabled && window.android?.printTicketApp;	
	const printTextTicket = printTextTicketApk || printTextTicketOldSport;

	useEffect(() =>{
		var ev = new $.Event('remove'), orig = $.fn.remove;
		$.fn.remove = function() {
			$(this).trigger(ev);
			return orig.apply(this, arguments);
		}

		return () => {
			$.fn.remove = function() {
				return orig.apply(this, arguments);
			}
		}
	}, []);
	
	useEffect(() =>{
		if(!goOnWithPrint){
			return;
		}
		if(ticketData){
			const isHorseTicket = ticketData?.isibetHorseTicket || ticketData?.mstbetHorseTicket;
			if(!isHorseTicket){
				if(!ticketData.avoidMarketDescCalc){
					for(let ke in ticketData.events){
						const selection = ticketData.events[ke];				
						for(let km in selection.bets){
							const bet = selection.bets[km];
							let descScom = bet.rawDescScom;
							let descDraw = bet.rawDescDraw;
							
							if(!ticketData.psv){
								let betDataAggr = getAggregationAndBetFromBetId(bet.scomSogei, bet.handicap);
								if(betDataAggr.market == null && bet.handicap != 0){
									// searching for the parametric market
									betDataAggr = getAggregationAndBetFromBetId(bet.scomSogei, 0);
								}
								if(betDataAggr && betDataAggr.market){
									const betFromAgg = betDataAggr.market;
									const aggregation = betDataAggr.aggregation;
									let hcp = bet.handicap;
									if (isAsianHandicap(bet.scomSogei) && bet.codDraw === 2) {
										hcp *= -1;
									}
									if(betFromAgg.hideHandicap){
										/*
										 * 1) aggregate description overrides the market description
										 * 2) original market description overrides the draw description
										 * */
										if(aggregation){
											descScom = aggregation.descrizione;
											for(let ko in betFromAgg.odds){
												if(betFromAgg.odds[ko].id == bet.codDraw){
													const drawFromAgg = betFromAgg.odds[ko];
													descDraw = drawFromAgg.desc;
												}
											}
											descDraw = betFromAgg.desc + " " + descDraw;	                		
										}
									}
									else {
										descScom = betFromAgg.desc;
										
										// finding the compacted bet name
										if(aggregation && aggregation.compattate){
											for(let name in aggregation.compattate){
												const listMarket = aggregation.compattate[name];
												for(let mark in listMarket){
													const values = listMarket[mark].split("_");
													const scomSogei = window.parseInt(values[0]);
													const handicap = window.parseInt(values[1]);
													if(scomSogei === bet.scomSogei && handicap == bet.handicap){
														descScom = name;
														break;
													}
												}
											}
											if(aggregation.localeCmpDesc && aggregation.localeCmpDesc[descScom] && aggregation.localeCmpDesc[descScom][xs_languageCode]){
												descScom = aggregation.localeCmpDesc[descScom][xs_languageCode];
											}
										}
										
										if(betFromAgg.parametrica || betFromAgg.calculateHandicapDescription){
											descScom = parseHandicap(descScom, hcp, betFromAgg.tipoHandicap, null, bet.dia);
										}
										if(bet.bonus){
											descScom = "* " + descScom;
										}
										for(let ko in betFromAgg.odds){
											if(betFromAgg.odds[ko].id == bet.codDraw){
												const drawFromAgg = betFromAgg.odds[ko];
												descDraw = drawFromAgg.desc;
												if(drawFromAgg.tooltip && drawFromAgg.tooltip != '' && conf.tod){
													const teams = selection.descAvv.split(' - ');
													if(teams && teams.length > 1){
														descDraw = drawFromAgg.tooltip;
														descDraw = descDraw.replaceAll('{{TEAM1}}', teams[0]);
														descDraw = descDraw.replaceAll('{{TEAM2}}', teams[1]);
													}
												}
											}
										}
									}
								}
							}
							
							bet.printableDescScom = descScom;
							bet.printableDescDraw = descDraw;	
						}	
					}				
				}
			}
			// adding foreign shop data
			if(shopContext.enabled && shopContext.type === 'TERMINAL' && shopContext.operator.logged && !aamsEnviroment){
				ticketData.operator = shopContext.operator.operatorUsername;
				const agency = shopContext.operator.shopDescr?.length > 0? shopContext.operator.shopDescr : shopContext.operator.shopCode;
				ticketData.agency = agency;
			}
			
			if(!printTextTicket){
				//$("#frame-print-ticket").remove();
				removePrintIframe();
				// get the ticket html: NB: I'm passing the user as props, because in renderToString useContext return always a null context
				let htmlTicket = '';
				if(!isHorseTicket){
					if (ticketType === 'bordered') {
						htmlTicket = renderToString(<BorderedTicket customerLogo={customerLogo} aamsLogo={aamsLogo} conf={conf} user={user} skinProperties={skinProperties} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} isCashout={isCashout} terminalCopy={terminalCopy} printAgainTerminalRec={printAgainTerminalRec} />);
					} 
					else if (ticketType === 'plain') {
						htmlTicket = renderToString(<PlainTicket customerLogo={customerLogo} aamsLogo={aamsLogo} conf={conf} user={user} skinProperties={skinProperties} ticketData={ticketData} psvVincPiazzSports={props.psvVincPiazzSports} frontendType={frontendType} aamsEnviroment={aamsEnviroment} isCashout={isCashout} terminalCopy={terminalCopy} printAgainTerminalRec={printAgainTerminalRec} />);
					} 
					else if (ticketType === 'flashbet') {
						htmlTicket = renderToString(<FlashbetTicket customerLogo={customerLogo} aamsLogo={aamsLogo} conf={conf} user={user} skinProperties={skinProperties} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} isCashout={isCashout} terminalCopy={terminalCopy} printAgainTerminalRec={printAgainTerminalRec} />);
					}
				}
				else if(ticketData.isibetHorseTicket) {
					// ISIBET RECEIPT
					htmlTicket = renderToString(<IsibetHorseTicket customerLogo={customerLogo} aamsLogo={aamsLogo} conf={conf} user={user} skinProperties={skinProperties} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} isCashout={isCashout} terminalCopy={terminalCopy} printAgainTerminalRec={printAgainTerminalRec} />);
				}
				else if(ticketData.mstbetHorseTicket) {
					// MSTBET RECEIPT
					htmlTicket = renderToString(<MstbetHorseTicket customerLogo={customerLogo} aamsLogo={aamsLogo} conf={conf} user={user} skinProperties={skinProperties} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} isCashout={isCashout} terminalCopy={terminalCopy} printAgainTerminalRec={printAgainTerminalRec} />);
				}

				// load the css style string from the server
				const styleScriptTag = getTicketCssAndPrintScript(ticketData.idTicket);
				
				const htmlCodeWithCssAndScript = (window.XSocket? styleMarginZero : '') + styleScriptTag + htmlTicket;
				
				const browserPrinting = !props.mustBePrintedBySocket;

				if(browserPrinting){
					removePrintIframe(); // per sicurezza rimuovo l'eventuale iframe precedente
					const documentTitle = window.document.title;
					window.document.title = documentTitle+"_"+ticketData.idTicket;
					
					const iframe = document.createElement('iframe');
					$(iframe).attr({
						style : "height: 0px; margin: 0px; position: absolute; z-index: 1000000; border: solid 0px transparent; top: 0; left: 0;",
						id : "frame-print-ticket",
						src : "#" + new Date().getTime()
					});
					iframe.doc = null;
					iframe.doc = iframe.contentDocument ? iframe.contentDocument : (iframe.contentWindow ? iframe.contentWindow.document : iframe.document);
					iframe.autofocus = true;
					// HTML INJECT!
					iframe.srcdoc = htmlCodeWithCssAndScript;
					if(!ticketPrinterContext.testTicket){
						iframe.addEventListener('load', function() {		            
							console.debug("IFRAME TO PRINT " + ticketData.idTicket + " MOUNTED " + getFormattedFullTimestamp());			
							const cw = iframe.contentWindow;
				            cw.focus();
							cw.printTicket();	// invoking the window.print in the iframe	
							let unlockInterval = setInterval(() =>{
								try{
									if(iframe.contentWindow.PRINT_STATUS === 'DONE'){
										window.document.title  = documentTitle;
										// print done! close everything
										clearInterval(unlockInterval);
										console.log("PRINT DONE!");
										if(shopContext.enabled){
											setTimeout(() =>{
												removePrintOverlay();
											}, 2000);
										}
										else{
											removePrintOverlay();
										}
										removePrintIframe();
										ticketPrinterContext.reset();
									}
								}
								catch(e){
									clearInterval(unlockInterval);
									console.error("PRINT EXCEPTION: " + e);
									console.error("Print dialog closed");
									removePrintOverlay();
									ticketPrinterContext.reset();
								}

							},150);	
						});
						$(iframe).bind('remove', function(e) {
							console.debug("IFRAME TO PRINT " + ticketData.idTicket + " UNMOUNTED " + getFormattedFullTimestamp());
						});		
						
					}
					else{
						$(iframe).css({
							"position" : "absolute",
							"z-index" : 2000,
							"height" : "20000px",
							"background-color" : "white"
						})
					}
					// iniettiamo l'iframe nel dom. Verrà invocato l'onload che farà partire tutto il giro
					appendPrintIframe(iframe);
				}
				else{
					if(ticketData.psv){
						ticketData.vincPiazzByProviderAndSport = props.psvVincPiazzSports?.vincPiazzByProviderAndSport;
					}
					const ticketType = ticketData.isibetHorseTicket?'TICKET_PSIP':ticketData.mstbetHorseTicket?'TICKET_PSIP_MSTBET':ticketData.psv?'TICKET_PSV':'TICKET_PSQF';
					window.XSocket.printReceipt(ticketData, ticketType,user);
					ticketPrinterContext.reset();
				}
			}
			else{	
				if(printTextTicketOldSport){
					// I will print this ticket using the old xsport function (it will call android.printTicketApp)
					window.IS_TERMINAL_COPY = terminalCopy;
					window.IS_CASHOUT = isCashout;
					let textTicket = window.getTicketAppForReact(ticketPrinterContext.ticketData);
					window.printTicketApp(textTicket, ticketPrinterContext.ticketData.idTicket);
				}
				else {
					// i print using the functions inside this project
					const textTicket = getTextTicket(ticketPrinterContext.ticketData, terminalCopy, ticketPrinterContext.reprintTerminalReceipt);
					const bitmapLogo = customerLogo?.split('data:image/png;base64,')[1];
					
					if(bitmapLogo){
						window.android.printBitmap(bitmapLogo);
					}
					let device = 'TELPO';
					if(window.android?.getOsPrinter){
						try{
							device = window.android.getOsPrinter().toUpperCase();
						} catch(e){}
					}					
					if(window.android.printQrCode){
						let linkTemplate = conf.qrct;
						if(linkTemplate != null && linkTemplate.length > 0){
							linkTemplate= linkTemplate.replace(/{{TICKET}}/g, ticketPrinterContext.ticketData.idTicket);
							linkTemplate = linkTemplate.replace(/{{LANG}}/g, xs_languageCode);
							linkTemplate = linkTemplate.replace(/{{SYSTEM_CODE}}/g, systemCode);
							window.android.printQrCode(linkTemplate);
						}
					} 
					// print ticket body
					window.android.printTicketApp(textTicket, false);
					

					
					if(window.android.printBarcode && device !== 'SUNMIV2'){
						window.android.printBarcode(ticketPrinterContext.ticketData.idTicket);
						window.android.printTicketApp('      ' + ticketPrinterContext.ticketData.idTicket, false);
					}	
	
					if(conf.tad != null && conf.tad.fad != null && conf.tad.fad[xs_languageCode] != null){
						window.android.printTicketApp("\r\n" + conf.tad.fad[xs_languageCode], false);
					}

					window.android.printBitmap(whitespaceBitmap);					
				}
				ticketPrinterContext.reset(); // html has been already calculated.I don't need any retry and stuff from context at the end of the printing operation
			}
		}
		
	
	}, [ticketPrinterContext.ticketData, goOnWithPrint]);

	useEffect(() => {
		if(ticketPrinterContext.externalHtmlTicket){
			removePrintIframe();
			const finalHtml = printScript + (window.XSocket? styleMarginZero : '') + ticketPrinterContext.externalHtmlTicket;
			const iframe = document.createElement('iframe');
			$(iframe).attr({
				style : "height: 0px; margin: 0px; position: absolute; z-index: 1000000; border: solid 0px transparent; top: 0; left: 0;",
				id : "frame-print-ticket",
				src : "#" + new Date().getTime()
			});
			iframe.doc = null;
			iframe.doc = iframe.contentDocument ? iframe.contentDocument : (iframe.contentWindow ? iframe.contentWindow.document : iframe.document);
			iframe.autofocus = true;
			// HTML INJECT!
			iframe.srcdoc = finalHtml;
			
			iframe.addEventListener('load', function() {		
				console.debug("IFRAME TO PRINT MOUNTED " + getFormattedFullTimestamp());            
				const cw = iframe.contentWindow;
				cw.focus();
				cw.printTicket();	// invoking the window.print in the iframe	
				let unlockInterval = setInterval(() =>{
					try{
						if(iframe.contentWindow.PRINT_STATUS === 'DONE'){
							// print done! close everything
							clearInterval(unlockInterval);
							console.log("PRINT DONE!");

							if(shopContext.enabled){
								setTimeout(() =>{
									removePrintOverlay(printOverlayRemoverFinalFunction);
								}, 2000);
							}
							else{
								removePrintOverlay(printOverlayRemoverFinalFunction);
							}
							removePrintIframe();
							ticketPrinterContext.reset();
						}
					}
					catch(e){
						clearInterval(unlockInterval);
						console.error("PRINT EXCEPTION: " + e);
						console.error("Print dialog closed");
						removePrintOverlay(printOverlayRemoverFinalFunction);
						ticketPrinterContext.reset();
					}

				},150);	
			});
			$(iframe).bind('remove', function() {
				console.debug("IFRAME TO PRINT  UNMOUNTED " + getFormattedFullTimestamp());
			});
			// on append finished, the frame 'on load' event listener will be triggered
			appendPrintIframe(iframe);

		}
	}, [ticketPrinterContext.externalHtmlTicket]);
	

	return null;
}

export default TicketPrinter;